import { Action } from "@ngrx/store";

import { SearchHint } from "../../data/model";
import { SearchState } from "./state";

export type Actions = Update | SetExtended | Reset;

export class Update implements Action {
    static readonly type = "search/update";
    readonly type = Update.type;

    constructor(
        public key: keyof SearchHint,
        public value: any,
    ) {}
}

export class SetExtended implements Action {
    static readonly type = "search/set-extended";
    readonly type = SetExtended.type;

    constructor(public value: boolean) {}
}

export class Reset implements Action {
    static readonly type = "search/reset";
    readonly type = Reset.type;
}
